import { render } from "./ErrorSubscriptionBlock.vue?vue&type=template&id=2d7362e2"
import script from "./ErrorSubscriptionBlock.vue?vue&type=script&lang=js"
export * from "./ErrorSubscriptionBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__